import { objectOf, func } from 'prop-types';
import _noop from 'lodash/noop';
import { choiceShape, choiceMetadataShape, productDataShape } from '../types';

export const choiceProps = {
  choice: choiceShape.isRequired,
  choiceMetaData: choiceMetadataShape.isRequired,
  product: productDataShape,
  quickViewHandler: func
};

export const choiceDefaultProps = {
  product: null,
  quickViewHandler: _noop
};
